import React from 'react';

import { PeriodPicker } from '@/shared/components/ui';

import { useAnalyticsPeriod } from '../../hooks/useAnalyticsPeriod';
import { ANALYTICS_PERIOD_SEGMENTS } from '../../utils/analytics-period';
import { QualityScoreCard } from './QualityScoreCard';
import { CostsCard } from './CostsCard';
import { PerformanceCard } from './PerformanceCard';
import { KnowledgeGapsCard } from './KnowledgeGapsCard';
import { RecentTracesTable } from './RecentTracesTable';

interface AnalyticsTabProps {
  agentId: string;
}

export const AnalyticsTab: React.FC<AnalyticsTabProps> = ({ agentId }) => {
  const { value: periodValue, onChange: setPeriodValue, period, range } = useAnalyticsPeriod();

  return (
    <div className="space-y-6">
      {/* Info Box */}
      <div
        className="p-4 rounded-lg border"
        style={{
          backgroundColor: 'var(--theme-info-background)',
          borderColor: 'var(--theme-info-color)',
        }}
      >
        <p
          className="text-sm"
          style={{ color: 'var(--theme-info-color)' }}
        >
          <strong>Analytics:</strong> métricas de qualidade, custos e
          performance do seu agente. Os dados são coletados automaticamente a
          cada execução e ficam disponíveis com um pequeno delay.
        </p>
      </div>

      {/* Period filter */}
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <h2
          className="text-lg font-semibold"
          style={{ color: 'var(--theme-card-text)' }}
        >
          Desempenho do agente
        </h2>
        <PeriodPicker
          value={periodValue}
          onChange={setPeriodValue}
          segments={ANALYTICS_PERIOD_SEGMENTS}
          ariaLabel="Período das análises"
          className="flex-wrap"
          data-testid="agent-analytics-period"
        />
      </div>

      {/* Cards grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <QualityScoreCard agentId={agentId} period={period} range={range} />
        <CostsCard agentId={agentId} period={period} range={range} />
        <PerformanceCard agentId={agentId} period={period} range={range} />
        <KnowledgeGapsCard agentId={agentId} period={period} range={range} />
      </div>

      {/* Recent traces table */}
      <RecentTracesTable agentId={agentId} period={period} range={range} />
    </div>
  );
};
